import BaseDownloadButtonView from "./baseDownloadButtonView";
import fontAwesomeIcon from "templates/downloadButton/fontAwesomeIcon.hbs";

class ContentDetailsPageDownloadButtonView extends BaseDownloadButtonView {
  constructor(options) {
    super(options);

    this.icon = fontAwesomeIcon;
    this.classNames = "";
  }
}

export default ContentDetailsPageDownloadButtonView;
